import React from 'react';

import {
	additionalServices,
	armsOfLoveText,
	disclaimerAddText,
	disclaimerText,
	disclaimerTitle,
	emergencyService,
	individualSupportText,
	memorializeText,
	memorializeTitle,
	navItems,
	petLossGroupLinkItems,
	petLossSupportGroupsText,
	specialitySupportGroupsText,
} from '@app/components/Pages/Services/PetLossSupportGroup/PetLossSupportGroupContent';
import CardLinks from '@app/components/UI/CardLinks/CardLinks';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import Masthead from '@app/components/UI/MastHead/Masthead';
import NavTabs from '@app/components/UI/NavTabs/NavTabs';
import RichText from '@app/components/UI/RichText/RichText';

const PetLossSupportGroup: React.FC = () => {
	const [currentIndex, setCurrentIndex] = React.useState<number>(0);

	const groupRef = React.useRef<any>();
	const journeyRef = React.useRef<any>();
	const personalRef = React.useRef<any>();
	const keepsakesRef = React.useRef<any>();

	const onSetIssue = (index) => {
		const refs = [journeyRef, personalRef, groupRef, keepsakesRef];
		let num: number = index;

		if (typeof index === 'string') {
			navItems.forEach((item, i: number) => {
				if (item.title === index) {
					num = i;
				}
			});
		}

		setCurrentIndex(num);
		refs?.[num]?.current?.scrollIntoView({ block: 'start' });
	};

	return (
		<HelmetProvider>
			<div className="our-services pet-loss-group">
				<Masthead
					title="Pet Loss Support"
					imageSrc={require('@app/content/petLossGroupHeader.jpg')}
					text="We’re here to do this together, and we’re here to give you permission to grieve."
					quoteAuthor="Dr. Dani McVety"
					buttonText={
						<a href="https://petloss.lapoflove.com/#contact" target="_blank" rel="noopener noreferrer">
							<button type="button" className="btn btn-sm btn-primary">
								Contact Us
							</button>
						</a>
					}
					imageAlt="Pet loss support"
				/>
				<div className="visible-mobile">
					<NavTabs navItems={navItems} currentIndex={currentIndex} onSetIssue={onSetIssue} navCollapse onChange={onSetIssue} />
				</div>
				<div className="no-visible-mobile">
					<NavTabs navItems={navItems} currentIndex={currentIndex} onSetIssue={onSetIssue} navCollapse={false} onChange={onSetIssue} />
				</div>
				<RichText
					title="Pet Loss Support Groups (Free!)"
					text={petLossSupportGroupsText}
					name={navItems[0].name}
					refRichText={journeyRef}
				/>
				<RichText
					title="Speciality Support Groups"
					text={specialitySupportGroupsText}
					name={navItems[1].name}
					refRichText={personalRef}
				/>
				<RichText
					title="Arms of Love - Understanding the Pet Loss Journey Courses"
					text={armsOfLoveText}
					name={navItems[2].name}
					refRichText={groupRef}
				/>
				<RichText
					title="1:1 Individual Pet Loss Support Session"
					text={individualSupportText}
					name={navItems[3].name}
					refRichText={keepsakesRef}
				/>
				<RichText
					title={memorializeTitle}
					text={memorializeText}
				/>
				<RichText
					title={disclaimerTitle}
					text={disclaimerText}
				/>

				<CardLinks list={emergencyService} />

				<RichText text={disclaimerAddText} />

				<CardLinks list={additionalServices} />
				<LinkBlockSmall items={petLossGroupLinkItems} />
			</div>
		</HelmetProvider>
	);
};

export default PetLossSupportGroup;
